// import moment from 'moment'
import { mapState } from 'vuex'
import { sceneTypes, all } from '../business/enums'
import { k12Scene, unitScene } from '../business/lang'

export default {
  data: () => ({
  }),
  computed: {
    ...mapState('school', [
      'currentOrg',
      'currentSchool'
    ]),
    appScene () {
      if (this.currentOrg.scene === sceneTypes.unit || this.currentSchool.scene === sceneTypes.unit) {
        return sceneTypes.unit
      }
      if (this.currentOrg.scene === sceneTypes.kindergarten || this.currentSchool.scene === sceneTypes.kindergarten) {
        return sceneTypes.kindergarten
      }
      return sceneTypes.k12
    },
    appIsDemo () {
      if (this.currentOrg.is_demo || this.currentSchool.is_demo) {
        return true
      }
      return false
    },
    sceneLang () {
      if (this.appScene === sceneTypes.unit) { // k12和kindergarten使用相同的文案
        return unitScene
      }
      return k12Scene
    },
    userTypes () {
      if (this.appScene === sceneTypes.unit) {
        return {
          all,
          student: '职员',
          others: '其他'
        }
      }
      return {
        all,
        student: '学生',
        teacher: '教师',
        others: '其他'
      }
    }
  },
  methods: {
    hasGroup (type) {
      if (type === 'student' || this.appScene === sceneTypes.unit) {
        return true
      }
      return false
    },
    k12Student (type) {
      if (type === 'student' && this.appScene !== sceneTypes.unit) {
        return true
      }
      return false
    }
  }
}
